export default "__VITE_ASSET__CQYqdjZS__"